import { apiWrapper } from './helpers';
import { checkErrorExist, convertError } from './converters';
import moment from 'moment';
import { handleFirstResponse } from '../utils/util_api_response';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';

// region Mark Topic As Read
export function markTopicAsRead(topicID) {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}/read`,
        'PATCH',
        'MARK TOPIC AS READ'
    );
}
// endregion

// region Mark All Topics As Read
export function markAllTopicAsRead() {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic-read`,
        'PATCH',
        'MARK ALL TOPICS AS READ'
    );
}
// endregion

// region Mark Comments as Read
export function markCommentsAsRead(topicID) {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}/read-comment`,
        'PATCH',
        'MARK COMMENTS IN TOPIC AS READ'
    );
}
// endregion

// region GET - TOPIC LIST
export function getTopicList(cityID, currentPage = 1, pageSize = 10, filterObj = {
    fillInNeededOnly: false,
    yourPosts: false,
    yourComments: false
}) {
    const link =
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic?city_id[]=${cityID}&page=${currentPage}&per_page=${pageSize}` +
        (filterObj.fillInNeededOnly ? `&fill_in_needed=1` : '') +
        (filterObj.yourPosts ? `&your_posts=1` : '') +
        (filterObj.yourComments ? `&your_comments=1` : '');

    console.log('[INFO] GET TOPIC LINK', link);

    return apiWrapper(
        link,
        'GET',
        `GET FORUM TOPIC LIST (CITY ID: ${cityID})`
    );
}
// endregion

// region GET - TOPIC COMMENTS
export function getTopicComment(topicID, currentPage = 1, pageSize = 20) {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}?page=${currentPage}&per_page=${pageSize}&sort_by=created_at&sort_type=asc`,
        'GET',
        `GET COMMENTS FOR TOPIC (ID: ${topicID})`
    );
}
// endregion

// region POST - TOPIC COMMENT
export function postTopicComment(topicID, content = '') {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}`,
        'POST',
        `POST COMMENT TO TOPIC (ID: ${topicID})`,
        JSON.stringify({ description: content }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region PATCH - TOPIC COMMENT
export function editTopicComment(topicID, commentID = -1, newContent = '') {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}/comment/${commentID}`,
        'PATCH',
        `EDIT COMMENT`,
        JSON.stringify({ description: newContent }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region DELETE - TOPIC COMMENT
export function deleteTopicComment(topicID, commentID = -1) {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}/comment/${commentID}`,
        'DELETE',
        `DELETE COMMENT`
    );
}
// endregion

// region POST - Mark Topic Filled
export function markTopicFilled(topicID, truckID = null) {
    return apiWrapper(
        `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic/${topicID}`,
        'PATCH',
        `MARK TOPIC AS FILLED`,
        truckID ? JSON.stringify({ is_filled: 1, filled_trucks: truckID.toString() }) : JSON.stringify({ is_filled: 1 }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region POST - NEW TOPIC
export function createNewTopic({
    title = '',
    description = '',
    imageList = [],
    servingCityIDs = [],
    fillInNeeded = false,
    eventDateStr = moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    onProgress = () => {}
}) {
    let data = new FormData();
    data.append('title', title);
    data.append('description', description);
    data.append('serving_city', servingCityIDs.map((cityID) => cityID).join(','));
    imageList.forEach((item, index) => data.append(`images[${index}]`, item));
    data.append('fill_in_needed', fillInNeeded ? 1 : 0);
    data.append('event_date', eventDateStr);

    console.log('[INFO] NEW TOPIC - SENDING DATA', data);

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/chat/${getGlobalState(STATE_KEYS.TRUCK_DATA)?.id}/topic`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            onProgress: (e) => onProgress(Number((e.loaded / e.total * 100).toFixed(2)))
        })
            .then((response) => handleFirstResponse(response?.response || {}))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] NEW TOPIC', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] NEW TOPIC', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] NEW TOPIC', error);
                reject(error.message);
            });
    });
}
// endregion

// region PATCH - TOPIC
export function updateTopic({
    id = 0,
    title = '',
    description = '',
    servingCityIDs = [],
    fillInNeeded = false,
    eventDateStr = moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    onProgress = () => {}
}) {
    let data = new FormData();
    data.append('title', title);
    data.append('description', description);
    data.append('serving_city', servingCityIDs.map((cityID) => cityID).join(','));
    data.append('fill_in_needed', fillInNeeded ? 1 : 0);
    data.append('event_date', eventDateStr);
    data.append('_method', 'PATCH');

    console.log('[INFO] UPDATE TOPIC - SENDING DATA', data);

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v2/chat/${GLOBAL.MAIN?.state.truckData.id}/topic/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: data,
            onProgress: (e) => onProgress(Number((e.loaded / e.total * 100).toFixed(2)))
        })
            .then((response) => handleFirstResponse(response?.response || {}))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log('[SUCCESS] UPDATE TOPIC', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] UPDATE TOPIC', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] UPDATE TOPIC', error);
                reject(error.message);
            });
    });
}
// endregion
